'use client';

import { useEffect, useState } from 'react';

import { ShareButton } from './ShareButton';

interface ShareButtonWrapperProps {
  articleTitle?: string;
  className?: string;
}

export const ShareButtonWrapper: React.FC<ShareButtonWrapperProps> = ({
  articleTitle,
  className
}) => {
  const [articleUrl, setArticleUrl] = useState<string>();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    if (typeof window !== 'undefined') {
      setArticleUrl(window.location.href);
    }
  }, []);

  // Prevent hydration mismatch by only rendering after mount
  if (!isMounted) {
    return (
      <div
        className={`${className || ''} flex size-9 items-center justify-center rounded-full border`}>
        <div className='bg-muted size-4 animate-pulse rounded' />
      </div>
    );
  }

  return (
    <ShareButton
      articleTitle={articleTitle}
      articleUrl={articleUrl}
      className={className}
    />
  );
};
